module.exports = __webpack_public_path__ + "img/18.14292095.png";